import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Step from './Step';
import * as styles from './Steps.scss';

/**
 * Reusable Steps Component
 * @function Steps
 * @param {Object} props
 * @return {ReactElement}
 */
const Steps = ({ className, onClick, stepData, style }) => {
  const steps = stepData.map((data, index) => {
    return (
      <Step
        key={data.title}
        className={data.className || null}
        countKey={index + 1}
        isActive={data.isActive || false}
        isComplete={data.isComplete || false}
        isDisabled={data.isDisabled || false}
        isError={data.isError || false}
        onClick={onClick}
        style={data.style || null}
        title={data.title}
      />
    );
  });

  return (
    <div className={classNames(styles.steps, className)} style={style}>
      {steps}
    </div>
  );
};

Steps.propTypes = {
  onClick: PropTypes.func.isRequired,
  stepData: PropTypes.arrayOf(
    PropTypes.shape({
      className: PropTypes.string,
      isActive: PropTypes.bool,
      isComplete: PropTypes.bool,
      isDisabled: PropTypes.bool,
      isError: PropTypes.bool,
      style: PropTypes.objectOf(
        PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]),
      ),
      title: PropTypes.string,
    }),
  ).isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
  ),
};

export default Steps;
